/**
 * @generated SignedSource<<a47c9b32edb42a861e4cd644dac8f8b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StripeHistoryTable_company$data = {
  readonly companyUserFiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly userFile: {
          readonly id: string;
          readonly kind: string;
          readonly " $fragmentSpreads": FragmentRefs<"StripeHistoryTableRow_userFile" | "StripeHistoryContextMenu_userFile">;
        } | null;
      };
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "StripeHistoryTable_company";
};
export type StripeHistoryTable_company$key = {
  readonly " $data"?: StripeHistoryTable_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"StripeHistoryTable_company">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "companyUserFiles"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./StripeHistoryTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "StripeHistoryTable_company",
  "selections": [
    {
      "alias": "companyUserFiles",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "CREATED_AT_DESC"
        }
      ],
      "concreteType": "CompanyUserFilesConnection",
      "kind": "LinkedField",
      "name": "__StripeHistoryTable_companyUserFiles_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyUserFilesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyUserFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserFile",
                  "kind": "LinkedField",
                  "name": "userFile",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "kind",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "StripeHistoryTableRow_userFile"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "StripeHistoryContextMenu_userFile"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__StripeHistoryTable_companyUserFiles_connection(orderBy:\"CREATED_AT_DESC\")"
    },
    (v1/*: any*/)
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "46b0da1f865a447c630d946a4b3354b5";

export default node;
